import { changeActivePane } from '@process-advisor/process-miner/api/methods/navigation/changeActivePane';
import { setFilterConstraint } from '@process-advisor/process-miner/api/methods/navigation/setFilterConstraint'
import { setVariantPane } from '@process-advisor/process-miner/api/methods/navigation/setVariantPane'
import { setFilterIcon } from '@process-advisor/process-miner/api/methods/navigation/setFilterIcon'
import { setConstraintIcon } from '@process-advisor/process-miner/api/methods/navigation/setConstraintIcon'
import { setDiscoveryIcon } from '@process-advisor/process-miner/api/methods/navigation/setDiscoveryIcon'
import { openSettings } from '@process-advisor/process-miner/api/methods/navigation/openSettings'
import { openFilterActivity } from '@process-advisor/process-miner/api/methods/navigation/openFilterActivity'
import { openAnalytics } from '@process-advisor/process-miner/api/methods/navigation/openAnalytics'
import { setAction_Dashboard } from '@process-advisor/process-miner/api/methods/navigation/setAction_Dashboard'
import { setAction_Consultant } from '@process-advisor/process-miner/api/methods/navigation/setAction_Consultant'
import { setAction_Visualizer } from '@process-advisor/process-miner/api/methods/navigation/setAction_Visualizer'
import { setAction_Cluster } from '@process-advisor/process-miner/api/methods/navigation/setAction_Cluster'
import { setAction_DecompositionTree } from '@process-advisor/process-miner/api/methods/navigation/setAction_DecompositionTree'
import { setAction_InfluenceAnalysis } from '@process-advisor/process-miner/api/methods/navigation/setAction_InfluenceAnalysis'
import { setAction_Detail } from '@process-advisor/process-miner/api/methods/navigation/setAction_Detail'
import { setAction_Analytics } from '@process-advisor/process-miner/api/methods/navigation/setAction_Analytics'
import { setAction_DiscoveryRulesSummary } from '@process-advisor/process-miner/api/methods/navigation/setAction_DiscoveryRulesSummary'
import { setAction_DiscoveryRulesVisualizer } from '@process-advisor/process-miner/api/methods/navigation/setAction_DiscoveryRulesVisualizer'
import { setAction_DiscoveryRules } from '@process-advisor/process-miner/api/methods/navigation/setAction_DiscoveryRules'
import { setAction_Findings } from '@process-advisor/process-miner/api/methods/navigation/setAction_Findings'
import { setAction_FindingsSummary } from '@process-advisor/process-miner/api/methods/navigation/setAction_FindingsSummary'
import { setAction_FindingsVisualizer } from '@process-advisor/process-miner/api/methods/navigation/setAction_FindingsVisualizer'
import { setAction_Workflow } from '@process-advisor/process-miner/api/methods/navigation/setAction_Workflow'
import { setAction_Home } from '@process-advisor/process-miner/api/methods/navigation/setAction_Home'
import { setAction_Costs } from '@process-advisor/process-miner/api/methods/navigation/setAction_Costs'
import { setAction_Time } from '@process-advisor/process-miner/api/methods/navigation/setAction_Time'
import { updateTaskHistogram } from '@process-advisor/process-miner/api/methods/navigation/updateTaskHistogram'
import { updateGaugeCompliance } from '@process-advisor/process-miner/api/methods/navigation/updateGaugeCompliance'
import { updateGaugeAutomation } from '@process-advisor/process-miner/api/methods/navigation/updateGaugeAutomation'
import { updateGaugePerformance } from '@process-advisor/process-miner/api/methods/navigation/updateGaugePerformance'
import { setAction_Model } from '@process-advisor/process-miner/api/methods/navigation/setAction_Model';

export const navigationMethods = {
    changeActivePane,
    setFilterConstraint,
    setVariantPane,
    setFilterIcon,
    setConstraintIcon,
    setDiscoveryIcon,
    openSettings,
    openAnalytics,
    setAction_Dashboard,
    setAction_Consultant,
    setAction_Visualizer,
    setAction_Analytics,
    setAction_DiscoveryRules,
    setAction_Findings,
    setAction_FindingsSummary,
    setAction_FindingsVisualizer,
    setAction_DiscoveryRulesSummary,
    setAction_DiscoveryRulesVisualizer,
    setAction_Workflow,
    setAction_Home,
    setAction_Time,
    setAction_Cluster,
    setAction_DecompositionTree,
    setAction_InfluenceAnalysis,
    setAction_Detail,
    updateTaskHistogram,
    updateGaugeAutomation,
    updateGaugeCompliance,
    updateGaugePerformance,
    setAction_Costs,
    openFilterActivity,
    setAction_Model
};
